import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faTimes} from "@fortawesome/free-solid-svg-icons";
import {PrimaryButton} from "../../Buttons/PrimaryButton";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {useBoundStore} from "../../../Store/store";
import toast from "react-hot-toast";
import {TextInputReadOnly} from "../../Form/TextInputReadOnly";
import {DangerButton} from "../../Buttons/DangerButton";
import Star from "../../../Assets/images/star.svg";
import {useEffect, useState} from "react";
import {SelectInput} from "../../Form/SelectInput";
import {NumberInput} from "../../Form/NumberInput";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {RejectRegistrationDialog} from "./RejectRegistrationDialog";
import {EditRejectionRemarkDialog} from "./EditRejectionRemarkDialog";
import {BlackButton} from "../../Buttons/BlackButton";
import {isMyCcpSubdomain} from "../../../Utils/SubdomainHelper";

export const AdminRegistrationDetailDialog = (props) => {
    const {
        open,
        onClose,
        user,
        onUpdate,
        isRejected = false
    } = props;

    const {t} = useTranslation();

    const acceptRegistration = useBoundStore(state => state.acceptRegistration);
    const rejectRegistration = useBoundStore(state => state.rejectRegistration);
    const getAllContractTypes = useBoundStore((state) => state.getAllContractTypes);
    const contractTypes = useBoundStore((state) => state.contractTypes);

    const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false);
    const [isEditRemarkDialogOpen, setIsEditRemarkDialogOpen] = useState(false);

    const jobFunctions = [
        {value: 'A1', label: t('functions.A1'), id: 0},
        {value: 'A2', label: t('functions.A2'), id: 1},
        {value: 'A0', label: t('functions.A0'), id: 2},
        {value: 'A3', label: t('functions.A3'), id: 3}
    ]

    useEffect(() => {
        getAllContractTypes().then(r => {});
    }, [getAllContractTypes]);

    useEffect(() => {
        reset({
            hourly_rate: user?.hourly_rate ?? 0,
        })
    }, [user?.hourly_rate]);

    const schema = yup.object({
        hourly_rate: yup
            .string()
            .required()
    }).required();

    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
        getValues,
        watch,
    } = useForm({
        resolver: yupResolver(schema),
        reValidateMode: 'onBlur',
        mode: 'onChange',
        defaultValues:{
            hourly_rate: user?.hourly_rate ?? '',
        }
    });

    const hourlyRateValue = watch('hourly_rate');

    const onSubmit = (data) => {
        acceptRegistrationHandler(data).then(r=>{});
    }

    const acceptRegistrationHandler = async (data) => {
        await acceptRegistration(user.id, data).then(response => {
            if (response) {
                toast.success(t('registrations.toast_accepted'));
                onClose();
                onUpdate();
            } else {
                toast.error(response);
            }
        })
    }

    const parseAddressField = (user, item, idx) => {
        return (
            <div className="mb-2 flex flex-col justify-start" key={idx}>
                <p className="font-bold leading-3 -mb-2 text-lg mt-4">{t(`general.fields.address`)}:</p>
                <div>{Object.entries(user[item] ?? {})?.map(([key, value], idx) => {
                    return (
                        <TextInputReadOnly translationIndex={`general.fields.${key}`} value={value ?? '-'} key={idx}/>
                    )
                })}</div>
            </div>
        )
    }

    const parseBranchesField = (user, item, idx, indexForced = 0) => {
        const forcedBranch = user[item][indexForced] ?? user[item];

        if(Array.isArray(forcedBranch)) {
            return (
                <div className="mb-2 flex flex-col justify-start" key={idx}>
                    <p className="font-bold leading-3 -mb-2 text-lg mt-4">{t(`general.fields.address`)}:</p>
                    <div>{forcedBranch?.map((branch, idx) => {
                        return (
                            <TextInputReadOnly translationIndex={t(`general.fields.${branch}`)} value={branch ?? '-'} key={idx}/>
                        )
                    })}</div>
                </div>
            )
        } else {
            return <div className="mb-2 flex flex-col justify-start" key={idx}>
                <p className="font-bold leading-3 -mb-2 text-lg mt-4">{t(`general.fields.address`)}:</p>
                <div>{Object.entries(forcedBranch ?? {})?.map(([key, value], idx) => {
                    if([
                        'id',
                        'max_hourly_rate_vk',
                        'max_hourly_rate_zk',
                        'shift_confirmed_message',
                        'alias',
                        'invoice_email',
                        'invoice_company_name',
                        'invoice_vat_number',
                        'invoice_street',
                        'invoice_number',
                        'invoice_bus',
                        'invoice_city',
                        'invoice_postal',
                        'contracts_email',
                        'contracts_firstname',
                        'contracts_lastname',
                        'performancestatement_email',
                        'performancestatement_firstname',
                        'performancestatement_lastname',
                    ].includes(key)) return false;
                    if(key === 'contract_type_id'){
                        return (
                            <TextInputReadOnly translationIndex={`general.fields.contract_type`} value={contractTypes.find(item => item.id == value)?.name ?? '-'} key={idx}/>
                        )
                    }
                    return (
                        <TextInputReadOnly translationIndex={t(`general.fields.${key}`)} value={value ?? '-'} key={idx}/>
                    )
                })}</div>
            </div>
        }
    }

    return (
        <Dialog className="relative z-50" open={open} onClose={onClose}>
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
            />

            <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="pointer-events-none overflow-y-scroll p-4 rounded-lg fixed inset-y-0 right-0 flex max-w-full">

                        <DialogPanel
                            transition
                            className="pointer-events-auto w-screen max-w-lg transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                        >
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="flex h-full rounded-2xl flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                                <div className="px-4 sm:px-6">
                                    <div className="flex items-start justify-between">
                                        <DialogTitle className="text-base font-semibold leading-6 text-gray-900">
                                            {t('registrations.registration_name', {name: user?.firstname})}
                                        </DialogTitle>
                                        <div className="ml-3 flex h-7 items-center">
                                            <button
                                                type="button"
                                                className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                                                onClick={() => onClose()}
                                            >
                                                <span className="absolute -inset-2.5" />
                                                <span className="sr-only">Close panel</span>
                                                <FontAwesomeIcon icon={faTimes} className="h-6 w-6" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="flex flex-row justify-between gap-4 mt-2 px-4 sm:px-6">
                                        <PrimaryButton> <a target={'_top'} href={`mailto:${user?.branches?.[0]?.contact_email}`}>{t('general.actions.send_email')}</a></PrimaryButton>
                                        <PrimaryButton> <a target={'_top'} href={`tel:${user.branches?.[0]?.contact_tel}`}>Tel</a></PrimaryButton>
                                    </div>
                                </div>

                                {isRejected && (
                                    <div className="mx-4 sm:mx-6 mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                                        <div className="flex justify-between items-start mb-2">
                                            <p className="font-bold text-red-900">{t('registrations.rejection_reason')}:</p>
                                            <BlackButton onClick={() => setIsEditRemarkDialogOpen(true)}>
                                                {t('general.actions.edit')}
                                            </BlackButton>
                                        </div>
                                        <p className="text-red-800">{user?.rejection_remark || t('general.labels.no_comment')}</p>
                                    </div>
                                )}

                                <div className="relative flex-1 px-4 sm:px-6">
                                    <div className="my-3">
                                        <p className="text-sm text-gray-500 mb-1">{t('registrations.statutes')}</p>
                                        <div className="flex flex-wrap gap-2">
                                            {(() => {
                                                const main = user?.main_statuut ?? 'freelance';
                                                const extras = user?.extra_statuten ?? [];
                                                const labels = {freelance: t('statuten.freelance'), interim: t('statuten.interim'), student: t('statuten.student'), flexi_job: t('statuten.flexi_job')};
                                                return (
                                                    <>
                                                        <span className="text-xs bg-primary text-white px-2 py-1 rounded">
                                                            {t('registrations.main_statute')}: {labels[main] ?? main}
                                                        </span>
                                                        {extras.map(s => (
                                                            <span key={s} className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded">
                                                                + {labels[s] ?? s}
                                                            </span>
                                                        ))}
                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                    {
                                        Object.keys(user).map((item, idx) => {
                                            if ([
                                                    'id', 'is_internal_client', 'approved_by', 'approved_at', 'type', 'average_rating', 'roles', 'contractType', 'max_hourly_rate_vk', 'max_hourly_rate_zk', 'confirmed_message', 'main_statuut', 'extra_statuten', 'rejection_remark'
                                                ].includes(item)) return false
                                            if(item === 'hourly_rate') {
                                                return (
                                                    <React.Fragment key={idx}>
                                                        <NumberInput step={0.01} register={register} translationIndex={'general.fields.hourly_rate'} name={'hourly_rate'} errors={errors}/>
                                                        {!isMyCcpSubdomain() && <span className={'text-sm text-gray-500'}><strong>{t('registrations.external_rate')}:</strong> {(() => { const v = Number(hourlyRateValue); if (!isFinite(v)) return '-'; const ext = Math.round((v * 1.18 + Number.EPSILON) * 100) / 100; return ext.toFixed(2).replace('.', ','); })()}</span>}
                                                    </React.Fragment>
                                                )
                                            }
                                            if(item === 'branches') {
                                                if(user['branches']?.length === 1) {
                                                    return parseBranchesField(user,item,idx, 0)
                                                }
                                            }
                                            if(item === 'function'){
                                                return (
                                                    <TextInputReadOnly translationIndex={t('general.fields.function')} value={jobFunctions.find(func => func.value == user[item] )?.label ?? '-'} key={idx}/>
                                                )
                                            }
                                            if (item === 'address') return (parseAddressField(user, item, idx))
                                            if (item === 'created_at') {
                                                return (
                                                    <TextInputReadOnly translationIndex={t('registrations.applied_on')} value={user[item].formatted ?? '-'} key={idx}/>
                                                )
                                            }
                                            if (item === 'company') {
                                                return (
                                                    <TextInputReadOnly translationIndex={`general.fields.${item}`} value={user[item]?.name} key={idx} />
                                                )
                                            }
                                            if(item === 'dont_agree_with_rate') {
                                                return (
                                                    <React.Fragment key={idx}>
                                                        <TextInputReadOnly translationIndex={t('registrations.agrees_with_rate')} value={user[item]?.dont_agree_with_rate ? t('general.labels.no') : t('general.labels.yes')}/>
                                                        <TextInputReadOnly translationIndex={'general.fields.rate_remark'} value={user[item]?.dont_agree_with_rate_explanation ?? '-'}/>
                                                    </React.Fragment>
                                                )
                                            }
                                            if (item === 'media') {
                                                return <div className="grid grid-cols-2 gap-4" key={idx}>
                                                    {
                                                        Object.entries(user[item] ?? {})?.map(([key, value], idx) => {
                                                            if(value === null) {
                                                                return <div
                                                                    className="mb-4 flex flex-row items-center justify-start"
                                                                    key={idx}>
                                                                    <p className="font-bold leading-3 underline mr-2">{t(`general.fields.${key}`)}: </p>
                                                                    <span>{t('general.labels.no_file')}</span>
                                                                </div>
                                                            }

                                                            return (
                                                                <div
                                                                    className="mb-4 flex flex-row items-center justify-start"
                                                                    key={idx}>
                                                                    <p className="font-bold leading-3 underline mr-2">{t(`general.fields.${key}`)}:</p>
                                                                    <a href={value?.url} target="_blank" className="group"
                                                                       download={true}>
                                                                        <FontAwesomeIcon className="group-hover:text-primary" icon={faDownload} />
                                                                    </a>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            return (
                                                <TextInputReadOnly translationIndex={`general.fields.${item}`} value={user[item] ?? '-'} key={idx} />
                                            )
                                        })
                                    }


                                    {!isRejected && (
                                        <div className={'flex flex-row justify-between gap-4'}>
                                            <DangerButton onClick={() => setIsRejectDialogOpen(true)}>{t('general.actions.reject')}</DangerButton>
                                            <PrimaryButton type="submit">{t('general.actions.accept')}</PrimaryButton>
                                        </div>
                                    )}
                                </div>
                            </div>
                            </form>
                        </DialogPanel>
                    </div>
                </div>
            </div>

            <RejectRegistrationDialog
                isOpen={isRejectDialogOpen}
                onClose={() => setIsRejectDialogOpen(false)}
                userId={user?.id}
                onUpdate={() => {
                    onUpdate();
                    onClose();
                }}
            />

            <EditRejectionRemarkDialog
                isOpen={isEditRemarkDialogOpen}
                onClose={() => setIsEditRemarkDialogOpen(false)}
                userId={user?.id}
                currentRemark={user?.rejection_remark}
                onUpdate={(updatedRemark) => {
                    onUpdate();
                    if (updatedRemark) {
                    }
                }}
            />
        </Dialog>
    )
}